import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {
  AfterContentChecked,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { SortingDirection } from "../preset-header-cell/preset-header-cell.component";

@Component({
  selector: "iv-live-preset-header",
  templateUrl: "./preset-header.component.html",
  styleUrls: [
    "./preset-header.component.scss",
    "../header/header.component.scss",
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresetHeaderComponent implements AfterContentChecked {
  @Input() row;
  @Input() isPreset: boolean;
  @Output() private onSymbolSortChanged: EventEmitter<string> = new EventEmitter();
  public symbolSort = SortingDirection.off;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  public ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.row, event.previousIndex, event.currentIndex);
  }

  public toggleSortBySymbol(): void {
    switch (this.symbolSort) {
      case SortingDirection.off: {
        this.symbolSort = SortingDirection.asc;
        this.onSymbolSortChanged.emit(SortingDirection.asc);
        break;
      }
      case SortingDirection.asc: {
        this.symbolSort = SortingDirection.desc;
        this.onSymbolSortChanged.emit(SortingDirection.desc);
        break;
      }
      case SortingDirection.desc: {
        this.symbolSort = SortingDirection.off;
        this.onSymbolSortChanged.emit(SortingDirection.off);
        break;
      }
      default: {
        this.symbolSort === SortingDirection.off;
      }
    }
  }

  public setOffSortBySymbol():void {
    this.symbolSort = SortingDirection.off;
    this.onSymbolSortChanged.emit(SortingDirection.off);
  }
}
